import React from "react";
import { Alert, Container } from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import styled from "styled-components";
import BlarneyStone from "./images/Commercial/BlarneyStone_Web.jpg";
import CivicCenter from "./images/Commercial/CivicCenter_Web.jpg";
import CivicCenterSide from "./images/Commercial/CivicCenterSide_Web.jpg";
import Dans from "./images/Commercial/Dans_Web.jpg";
import FamilyWellness from "./images/Commercial/FamilyWellness_Web.jpg";
import NorthMarketplace from "./images/Commercial/NorthMarketplace_Web.jpg";
import ScheelsCenter from "./images/Commercial/ScheelsCenter_Web.jpg";

const SliderImg = styled.img`
  width: 100%;
  overflow: hidden;
  `;

const CommercialProducts = props => {
  return (
    <Container>
      <h2>Commercial Products</h2>
      <hr />
      <Carousel infiniteLoop showThumbs={false} showIndicators={false}>
        <div>
          <SliderImg src={ScheelsCenter} />
        </div>
        <div>
          <SliderImg src={BlarneyStone} />
        </div>
        <div>
          <SliderImg src={CivicCenter} />
        </div>
        <div>
          <SliderImg src={CivicCenterSide} />
        </div>
        <div>
          <SliderImg src={Dans} />
        </div>
        <div>
          <SliderImg src={FamilyWellness} />
        </div>
        <div>
          <SliderImg src={NorthMarketplace} />
        </div>
      </Carousel>
<div style={{marginTop: "20px"}}>
<Alert  color="info">
        <h2>Code Performance</h2>
        <p>Confused as to whether or not the system you have will meet the 2015 International Energy Conservation Code(IECC) North Dakota adopted 1/1/2017? Give us a call, We're glad to help you find the right product for the job. Whether it be a new high-performance storefront with a dual-pour and de-bridged thermal breaks such as Tubelite's <a href="https://www.tubeliteinc.com/tu24000/" target="_blank" rel="noopener noreferrer">TU24000</a>, or a high-performance thermal strut curtain wall like Tubelite's <a href="https://www.tubeliteinc.com/tu24000/400TU" target="_blank" rel="noopener noreferrer">400TU</a> system. We'll help you find the most cost-effective way to meet the stringent new code in our area.</p>
      </Alert>
      <h2>Commercial Storefront</h2>
      <p>
      Red River Glazing designs and fabricates custom windows, doors, and storefronts to fit your needs. Using state of the art CNC machines our experienced team fabricates our custom aluminum products with high-tech accuracy. We fabricate our custom products out of our Fargo location and install on site.
      </p>
      <p>
      Currently we stock, Clear and Dark Bronze Aluminum and Medium and Wide Door Rails.  Need a different door stile, or storefront color? We often have additional on hand, call us for details. We can also order other colors with timely turnaround time as requested.
      </p>
      <p>
      Our experienced Project Managers can help you spot project problems early in the process and are experts at bringing your project in on budget and on time.
      </p>
      <h2>Automatic Operators</h2>
      <p>
      Red River Glazing regularly helps our customers find the best Automatic Door solution for their projects. We help businesses create a professional atmosphere with our sliding, folding or swinging automatic operators.
      </p>
      <p>
        Give your business a New, Professional look &amp; Feel with a Sliding, Folding, or Swinging Operator Today! We can also Retrofit existing automatic entrances to meet the ever-changing ANSI code and accessibly needs.
      </p>
      <p>
      Our American Association of Automatic Door Manufacturers certified technicians service all brands and models of automatic doors, with specialists for Record, NABCO, and Stanley products. We are also experienced in retrofitting existing automatic entrances to meet updated ANSI Code and new Accessibility needs.  
      </p>
      <img
        title="AAADM LOGO"
        src="http://rrginc.net/wp-content/uploads/2010/01/AAADM-LOGO-e1286919567410.png"
        alt="We AAADM Certify All of our Automatic Door Technicians"
        width="542"
        height="55"
        style={{margin: "10px 0 20px 0"}}
      />
      <h2>Caulking</h2>
      <p>
      Whether your current caulking is leaking, or a new installation needs to be caulked Red River Glazing's experienced technicians can professionally seal your installations. We stock Dow Corning Silicon as well as Tremco’s Dymonic and Tremsil products.
      </p>
   
      <h2>Curtain Wall</h2>
      <p>
      Red River Glazing has extensive experience with small and large curtain wall projects. We can fabricate standard office entry doors but can also take on projects with unique bends, corners, and angles.
      </p>
      <p>In order to better serve our customers, we have designed:</p>
      <ul>
        <li>

        New dies to meet the artistic needs of our customers and their architects
        </li>
        <li>Systems with the ability to be anchored at special and unique locations</li>
        <li>Systems incorporating cathedral arches, circles, and other curves</li>
        <li>Systems to meet a multitude of architects' needs.</li>
      </ul>
      <p>
      If you can dream it, we’ll do our best to make it a reality.
      </p>
      <h2>Metal Panels</h2>
      <p>
      Red River Glazing also can enhance the aesthetics of your building using metal panels. We use panels ranging from 1/4” to 1” in both dry and wet designs. From column posts to canopies, we help our customers get the curb appeal that they seek.
      </p>
      </div>
    </Container>
  );
};

export default CommercialProducts;



// WEBPACK FOOTER //
// ./src/CommercialProducts.js